module.exports = __webpack_public_path__ + "static/img/08102649wul9.5367db62.jpg";